import { environment as base } from './environment.base';

export const environment = {
  ...base,
  code: 'verv'
};
